import { gql } from '@apollo/client';
import {
  ArticleSummary,
  MutationUpdateArticleSummaryArgs,
} from '../../../__generated__/queries-web';

export const UPDATE_ARTICLE_SUMMARY = gql`
  mutation UpdateArticleSummary(
    $where: ArticleSummaryUniqueFilterInput!
    $data: ArticleSummaryUpdateInput!
  ) {
    updateArticleSummary(where: $where, data: $data) {
      id
      status
    }
  }
`;

export interface UpdateArticleSummaryMutation {
  updateArticleSummary: Pick<ArticleSummary, 'id' | 'status'>;
}

export type UpdateArticleSummaryMutationVariables = MutationUpdateArticleSummaryArgs;
